import { call, put } from 'redux-saga/effects';
import { requestFieldPermission } from '../requesters/sharingRequester';
import { receiveFieldPermission } from '../actions/sharingActions';

/**
 * Calls the requester to get the field permission for the current authenticated user
 * @param {String} fieldId
 * @return {void}
 */
export function* getFieldPermission(fieldId) {
  const response = yield call(requestFieldPermission, fieldId);

  if (response && response.authorized && response.authorized.length) {
    const { permission } = response.authorized[0];
    yield put(receiveFieldPermission(permission));
    return permission;
  }

  throw new Error('Not permitted to view this field');
}
